import useWebSocket, { ReadyState, Options } from 'react-use-websocket';
import { useAuth } from 'store/auth/hooks';
type params = {
  url?: string;
  options?: Options;
  eventTypeFilter?: string[];
};

export const useWebSocketEvents = ({ url, options }: params = {}) => {
  const { accessToken } = useAuth();
  const { readyState, lastJsonMessage, getWebSocket } = useWebSocket(
    url || process.env.REACT_APP_WEB_SOCKET_GATEWAY_URL || '',
    {
      queryParams: { authKey: accessToken || '' },
      share: false,
      onOpen: (event) => {
        console.log('WebSocket connected', event);
      },
      onClose: (event) => {
        console.log('WebSocket disconnected', event);
      },
      onError: (event) => {
        console.error('WebSocket error', event);
      },
      shouldReconnect: (closeEvent) => true,
      reconnectAttempts: 1000,
      ...options,
    },
  );

  const connectionStatus: string = ReadyState[readyState];
  // lastJsonMessage is the last message received from the server use this in your component to update the UI if events are fired very fast the order is not guaranteed
  return { connectionStatus, lastJsonMessage, getWebSocket };
};
